import React, { Component } from 'react';
import { Switch, Route, Router } from 'react-router-dom';
import HeaderPage from './header/Header';
import LeftPanel from './LeftPanel';
class MainPage extends Component {
  render() {
    return (
      <div style={{ backgroundColor: '#F9F9FB' }}>
        {/* Navbar */}
        <div id="navBar">
          <HeaderPage />
        </div>
        {/* Left panel */}
        <div className="content-wrapper" id="leftPanel" >
          <Route path='/projectmgmt' component={LeftPanel}></Route>
          {/* <LeftPanel />  */}
        </div>


      </div>




    );
  }
}

export default MainPage;


// WEBPACK FOOTER //
// ./src/projectmgmt/MainPage.js